import { render, staticRenderFns } from "./purchasereturns_report.vue?vue&type=template&id=3d72d6f5&"
import script from "./purchasereturns_report.vue?vue&type=script&lang=js&"
export * from "./purchasereturns_report.vue?vue&type=script&lang=js&"
import style0 from "./purchasereturns_report.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports